import { render } from "./CandidatosVagaVie.vue?vue&type=template&id=7ea7f8ec"
import script from "./CandidatosVagaVie.vue?vue&type=script&lang=js"
export * from "./CandidatosVagaVie.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__